export default "__VITE_ASSET__a9a3cb39__"